var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygonGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.766,
    height: 45,
    viewBox: "0 0 39.766 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_611",
    "data-name": "Caminho 611",
    d: "M31.561,0a4.418,4.418,0,0,1,3.817,2.192L44.4,17.657a4.418,4.418,0,0,1,0,4.453L35.377,37.574a4.418,4.418,0,0,1-3.817,2.192H13.439a4.418,4.418,0,0,1-3.817-2.192L.6,22.109a4.418,4.418,0,0,1,0-4.453L9.623,2.192A4.418,4.418,0,0,1,13.439,0Z",
    transform: "translate(39.766) rotate(90)",
    fill: "#eee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonGrey);
export default __webpack_public_path__ + "static/media/Polygon_grey.5047d4113d1b68e7749d10dffb88ff32.svg";
export { ForwardRef as ReactComponent };